import React, { Suspense } from 'react';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import { render } from 'react-dom';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import SnackbarAlert from '@fingo/lib/contexts/snack-bar';
import { OAuthCallbackHandler } from '@fingo/lib/components/auth';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import TranslationProvider from '@fingo/lib/components/translation/TranslationProvider';
import FingoCircularProgressLoader from '@fingo/lib/components/loader/FingoCircularProgressLoader';
import { lazy } from '@loadable/component';
import client from '@fingo/lib/apollo';
import theme from './theme';
import PrivateRoute from './components/router/PrivateRoute';
import { Layout } from './components/layout';

const Login = lazy(() => import(/* webpackChunkName: "login" */ './views/Login'));
const App = lazy(() => import(/* webpackChunkName: "app" */ './views/App'));

const Lucila = () => (
  <ThemeProvider theme={theme}>
    <CssBaseline>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <ApolloProvider client={client}>
          <StyledEngineProvider injectFirst>
            <SnackbarAlert />
            <Router>
              <TranslationProvider platform={process.env.REACT_APP_ACTIVE_REQUESTING_PLATFORM} mode="platform">
                <OAuthCallbackHandler>
                  <Layout>
                    <Suspense fallback={<FingoCircularProgressLoader />}>
                      <Switch>
                        <PrivateRoute path="/app" component={App} />
                        <Route exact path="/login" component={Login} />
                        <Route exact path="/" component={Login} />
                      </Switch>
                    </Suspense>
                  </Layout>
                </OAuthCallbackHandler>
              </TranslationProvider>
            </Router>
          </StyledEngineProvider>
        </ApolloProvider>
      </LocalizationProvider>
    </CssBaseline>
  </ThemeProvider>
);

render(<Lucila />, document.getElementById('root'));
